module.exports = __webpack_public_path__ + "static/media/virtual-controls.a17e3e29.png";